import { render, staticRenderFns } from "./EditPhoto.vue?vue&type=template&id=291eb1e4&scoped=true&"
import script from "./EditPhoto.vue?vue&type=script&lang=js&"
export * from "./EditPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291eb1e4",
  null
  
)

export default component.exports